var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderDBarna(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 14.485C24 10.957 20.5402 8 16.0064 8C11.4726 8 8 10.959 8 14.4881C8 15.6522 8.20736 16.5303 8.91072 17.5339H8.89728L15.7421 27.8811C15.9994 28.1576 16.2694 27.8651 16.2694 27.8651C16.0384 28.1366 23.1142 17.5339 23.1142 17.5339H23.1085C23.8048 16.5303 24 15.6502 24 14.485ZM12.3206 14.2863C12.3206 12.6219 13.9712 11.2736 16.0064 11.2736C18.041 11.2736 19.6928 12.6219 19.6928 14.2863C19.6928 15.9508 18.041 17.2995 16.0064 17.2995C13.9712 17.2995 12.3206 15.9513 12.3206 14.2863Z",
    fill: "#176318"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderDBarna);
export default __webpack_public_path__ + "static/media/HeaderDBarna.3164141d0aea3a3bd22fd33cbdf7563b.svg";
export { ForwardRef as ReactComponent };